export const CURRENT_RETURN_ELEMENT = 'CURRENT_RETURN_ELEMENT';
export const INDEX_OF_EDIT_ELEMENT = 'INDEX_OF_EDIT_ELEMENT';
export const WARRANTY_RETURN_ITEM = 'WARRANTY_RETURN_ITEM';
export const CONTACT_ADDRESS = 'CONTACT_ADDRESS';
export const PLACE_OF_INCIDENT_OPTIONS = 'PLACE_OF_INCIDENT_OPTIONS';

const initialState = {
  currentReturnItem: [],
  indexOfEditElement: null,
  indexOfReturnItem: null,
  warrentyReturnItem: {},
  contactAddress: [],
  placeOfIncidentOptions: [],
};

export default (state = initialState, action) => {
  switch (action.type) {
    case CURRENT_RETURN_ELEMENT: {
      return {
        ...state,
        currentReturnItem: action?.payload?.values,
        indexOfReturnItem: action?.payload?.selectedItem,
      };
    }
    case INDEX_OF_EDIT_ELEMENT: {
      return {
        ...state,
        indexOfEditElement: action?.payload?.eleIndex,
      };
    }
    case WARRANTY_RETURN_ITEM: {
      return {
        ...state,
        warrentyReturnItem: action?.payload,
      };
    }
    case CONTACT_ADDRESS: {
      return {
        ...state,
        contactAddress: action?.payload,
      };
    }
    case PLACE_OF_INCIDENT_OPTIONS: {
      return {
        ...state,
        placeOfIncidentOptions: action?.payload || [],
      };
    }
    default:
      return state;
  }
};

export const setPlaceOfIncidentOptions = (data) => ({
  type: PLACE_OF_INCIDENT_OPTIONS,
  payload: data,
});

export const headerProductSearch = loader => ({
  type: CURRENT_RETURN_ELEMENT,
  loader,
});

